import { FilterAltTwoTone } from '@mui/icons-material'
import { Button, IconButton, Stack } from '@mui/material'

const FilterButton = ({ onClick, hasActiveFilters, handleClearAllFilters }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <IconButton
        onClick={onClick}
        title="Click to refresh the list"
        size="large"
        color={hasActiveFilters ? 'primary' : 'secondary'}
        sx={{
          border: '1px solid #6c757d',
          color: '#6c757d',
          padding: '8px',
        }}
      >
        <FilterAltTwoTone />
      </IconButton>

      {hasActiveFilters && (
        <Button
          variant="outlined"
          size='large'
          color='secondary'
          onClick={handleClearAllFilters}
        >
          Clear Filters
        </Button>
      )}
    </Stack>
  )
}

export default FilterButton
